import './App.css';
import './V2HomeMenu.css';
import UserHeader from './UserHeader';
import { useNavigate } from 'react-router-dom';

function V2HomeMenu() {
    const navigate = useNavigate();

    return (
        <div className='v2-home-menu'>
            <div
                onClick={() => navigate('/feed')}
                style={{
                    padding: '1em',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                }}
            >
                <div
                    style={{ display: 'flex', alignItems: 'center', }}
                >
                    <i className="pi pi-home"></i>
                    <div style={{ marginLeft: '0.2em' }}>
                        Home
                    </div>
                </div>
            </div>
            <div style={{ marginLeft: 'auto' }}>
                <UserHeader
                    user_id='me'
                    onClick={() => navigate('/myaccount')}
                />
            </div>
        </div>
    );
}

export default V2HomeMenu;